export default {
    state: { 
        isAuth:false,
        account:{}
     },
    mutations: {
        // SETAUTH(state,user){
        //     state.isAuth = true
        //     state.account = user
        // }
     },
    actions: {

     }
  }